import { inject, Injectable } from '@angular/core';
import { Route, Router, Routes } from '@angular/router';
import { PageRegistryDto } from '../dtos/page-registry.dto';
import { PageTypeEnum } from '../enums/page-type.enum';
import { ResponseDto } from '../dtos/response.dto';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { buildAllRoutes, buildBlogRoute, DUMMY_ROUTE } from '../app.routes';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PageRegistryService {
  private http = inject(HttpClient);
  private router = inject(Router);

  fetchPagesAndUpdateRouterConfig(): void {
    this.http.get<ResponseDto<PageRegistryDto[]>>(`${environment.apiHost}/api/v1/pages`).subscribe(response => {
      this.updateRouterConfig(response.data);
    });
  }

  fetchPageAndUpdateRouterConfig$(slug: string): Observable<ResponseDto<PageRegistryDto>> {
    const url = `${environment.apiHost}/api/v1/pages/${slug}`;
    return this.http.get<ResponseDto<PageRegistryDto>>(url)
      .pipe(
        tap({ next: response => this.updateRouterConfig([response.data]) }),
      );
  }

  updateRouterConfig(pages: PageRegistryDto[]): void {
    const blogRoute = buildBlogRoute();
    const dynamicRoutes: Routes = [];

    pages.forEach(page => {
      const path = page.slug;
      const loadComponent = DUMMY_ROUTE.children.find(route => route.path === page.type).loadComponent;

      const route: Route = {
        path,
        loadComponent,
        data: {
          slug: page.slug,
        },
      };

      const isBlogPage = page.type === PageTypeEnum.BlogPost || page.type === PageTypeEnum.BlogCategory;
      if (isBlogPage) {
        blogRoute.children.push(route);
      } else {
        dynamicRoutes.push(route);
      }
    });

    this.router.resetConfig(buildAllRoutes(blogRoute, dynamicRoutes));
  }
}
